import React, { ReactNode, ReactElement, cloneElement, isValidElement } from 'react';
import { usePremiumGate } from '../hooks/usePremiumGate';
import { PremiumFeatureCode, UpgradeModalConfig } from '../types';

interface PremiumGateProps {
  children: ReactNode;
  featureCode?: PremiumFeatureCode;
  currentUsage?: number;
  feature?: string;
  description?: string;
  fallback?: ReactNode;
  showLockedState?: boolean;
}

export const PremiumGate: React.FC<PremiumGateProps> = ({
  children,
  featureCode,
  currentUsage = 0,
  feature,
  description,
  fallback,
  showLockedState = false,
}) => {
  const { isLocked, gate } = usePremiumGate(featureCode, currentUsage);

  const modalConfig: UpgradeModalConfig = {
    feature,
    description,
    source: 'feature_gate',
  };

  if (isLocked && fallback) {
    return <>{fallback}</>;
  }

  if (!isValidElement(children)) {
    return <>{children}</>;
  }

  const child = children as ReactElement<any>;

  const handleClick = (e: React.MouseEvent) => {
    if (isLocked) {
      e.preventDefault();
      e.stopPropagation();
      gate(() => {}, modalConfig);
      return;
    }

    if (child.props.onClick) {
      child.props.onClick(e);
    }
  };

  return cloneElement(child, {
    onClick: handleClick,
    style: {
      ...child.props.style,
      ...(isLocked && showLockedState ? { opacity: 0.6, cursor: 'pointer' } : {}),
    },
  });
};
